import _ from 'underscore';
class BulkActions {
  constructor(el, args) {
    this.cid = _.uniqueId('bulk');
    this.$ = window.$;
    this.$el = this.$(el);
    _.mapObject(args, (value, key) => {
      this[key] = value;
    });
    this.selected = [];
    this.selectedObjects = [];
    this.selectedAll = false;
    this.attach();
    this.listen();
  }

  get dom() {
    return {
      BULK_CONTAINER: '.bulk_actions_container',
      BULK: '.bulk_actions',
      SELECT_ALL: '#select-all',
      CHECKBOXES: '.row-checkbox',
      CHECKED_POLICY: '.row-checkbox:checked',
    };
  }

  detach() {
    this.$el.off(`.delegateEvents${this.cid}`);
  }

  listen() {
    this.$el.on(`change.delegateEvents${this.cid}`, this.dom.SELECT_ALL, (e) =>
      this._toggleCheckboxes(e),
    );
    this.$el.on(`change.delegateEvents${this.cid}`, this.dom.CHECKBOXES, (e) =>
      this._verifyUncheck(e),
    );
    this.$el.on(`change.delegateEvents${this.cid}`, this.dom.BULK, (e) =>
      this._handleSubmit(e),
    );
  }

  attach() {
    let select2HTML = [];

    select2HTML.push(
      '<label #bulk-label>Payment Device Actions: </label><select class="select2select bulk_actions"> \
                      <option value=""></option>',
    );
    _.mapObject(this.actions, (opts, action) => {
      let extraData = '';

      if (typeof opts.disabledMessage !== 'undefined') {
        extraData = `data-disabled-message="${opts.disabledMessage}"`;
      }

      select2HTML.push(
        `<option value="${action}" ${extraData}>${opts.text}</option>`,
      );
    });
    select2HTML.push('</select');
    $(this.dom.BULK_CONTAINER).html(select2HTML.join(''));

    this._select2Initialize();
    this._toggleDropdown();
  }

  registerCondition(action, conditionFunction) {
    this.actions[action] = conditionFunction;
  }

  _select2Initialize() {
    this.$(this.dom.BULK).select2({ placeholder: 'With selected...' });
  }

  _updateSelected(checked) {
    this.selectedAll = checked;
    this.selected = [];
    this.selectedObjects = [];
    $("input.row-checkbox[type='checkbox']:not(:disabled):checked").each(
      (i, item) => {
        this.selectedObjects.push($(item).data('attr'));
        this.selected.push(item.value);
      },
    );
    this._checkConditions();
  }

  _checkConditions() {
    _.mapObject(this.actions, (actionData, action) => {
      let $option = $(this.dom.BULK).find(`option[value="${action}"]`);

      $option.removeAttr('title').prop('disabled', false);
      if (!actionData.conditionCheck(this.selectedObjects, this.selectedAll)) {
        $option.attr('disabled', 'disabled');
        if (typeof $option.data('disabled-message') !== 'undefined') {
          $option.attr('title', $option.data('disabled-message'));
        }
      }
      this._select2Initialize();
    });
  }

  _toggleDropdown() {
    const selectAllElement = this.$(this.dom.SELECT_ALL);
    const checked = selectAllElement.is(':checked');
    const container = $(this.dom.BULK).next('.select2-container');

    this._updateSelected(checked);
    if (!checked && this.selected.length === 0) {
      container.addClass('hidden');
    } else if ((checked && window.anySelectable) || this.selected.length > 0) {
      container.removeClass('hidden');
    }
  }

  _handleSubmit(e) {
    let actionData;

    if (e.target.value === '') {
      return false;
    }

    actionData = this.actions[e.target.value];
    if (typeof actionData.callback !== 'undefined') {
      actionData.callback({
        baseURL: this._buildBaseURL(),
        selected: this.selected,
        selectedAll: this.selectedAll,
      });
      $(this.dom.BULK).val('');
      return;
    }
    this._submit(e);
  }

  _buildBaseURL() {
    let url = location.href.replace(location.hash, '');

    if (url.indexOf(this.controller) === -1) {
      url += this.controller;
    }
    return url;
  }

  _submit(e) {
    let url = this._buildBaseURL(),
      form = $(
        `<form action="${url}/${e.target.value}_confirmation" method="POST"></form>`,
      );

    form.append(
      `<input name="authenticity_token" value="${this.$('meta[name=csrf-token]').attr('content')}" />`,
    );
    form.append(
      `<input name="payment_device_ids" value="${this.selected.join(',')}" />`,
    );
    form.append(`<input name="select_all" value="${this.selectedAll}" />`);
    document.body.appendChild(form[0]);
    form.submit();
  }

  _verifyUncheck(e) {
    const checked = $(e.target).is(':checked');
    const selectAllElement = this.$(this.dom.SELECT_ALL);

    if (!checked && selectAllElement.is(':checked')) {
      selectAllElement.addClass('do-not-trigger');
      selectAllElement.trigger('click');
      this.$(this.dom.SELECT_ALL).removeClass('do-not-trigger');
    }
    this._toggleDropdown();
  }

  _toggleCheckboxes() {
    const selectAllElement = this.$(this.dom.SELECT_ALL);
    const checked = selectAllElement.prop('checked');
    const selector = checked ? ':not(:checked)' : ':checked';

    this._toggleDropdown();
    if (selectAllElement.hasClass('do-not-trigger')) {
      return;
    }
    $(
      `input[type='checkbox']${selector}:not(:disabled):not(#select-all)`,
    ).trigger('click');
  }
}

module.exports = BulkActions;
